module.exports = __webpack_public_path__ + "static/img/platform-group3.218bd479.png";